// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetHostConfigPagingResultModel from '../../model/widget-host-config-paging-result-model';
import WidgetHostConfigPagingResultDTO from '../dto/widget-host-config-paging-result-dto';
import dtoSchema from '../schemas/widget-host-config-paging-result-schema';
import WidgetHostConfigModel from '../../model/widget-host-config-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class WidgetHostConfigPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetHostConfigPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WidgetHostConfigModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: WidgetHostConfigModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<WidgetHostConfigPagingResultDTO>): WidgetHostConfigPagingResultModel;
  static toModel(dto: DeepPartial<WidgetHostConfigPagingResultDTO> | undefined | null): WidgetHostConfigPagingResultModel | undefined;
  static toModel(dto: DeepPartial<WidgetHostConfigPagingResultDTO> | undefined | null): WidgetHostConfigPagingResultModel | undefined {
    return dto ? new WidgetHostConfigPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetHostConfigPagingResultModel> | WidgetHostConfigPagingResultModel): WidgetHostConfigPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as WidgetHostConfigPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetHostConfigPagingResultModel, can not map to WidgetHostConfigPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
